import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import getDateTimeFromString from "../../utils/getDateTimeFromString";

const useStyles = makeStyles(() => ({
    labelInput: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "left",
        color: "rgba(128, 128, 143, 1)",
    },
    styleInput: {
        borderRadius: "4px",
        height: "36px",
        width: "250px",
        //padding: "14px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    container: {
        //marginBottom: "10px",
    },
    specialInput: {
        color: "rgba(24, 28, 50, 0.58)",
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "right",
        backgroundColor: "rgba(243, 246, 249, 1)",
        border: "none",
        width: "209px",
        height: "28px",
    },
    generalInput: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "right",
        color: "rgba(24, 28, 50, 1)",
        border: "none",
        backgroundColor: "rgba(255, 255, 255, 1)"
    },
    noteInput: {
        width: "305px",
        height: "77px",
        borderRadius: "4px",
        border: "1px solid rgba(0, 0, 0, 0.2)",
        background: "rgba(255, 255, 255, 1)",
        //textAlign: "right",
    },
    montantLabel: {
        color: "rgba(187, 200, 8, 1)",
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "left",
        marginBottom: "20px",
    },
    montantValue: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 600,
        textAlign: "right",
        color: "rgba(187, 200, 8, 1)",
        border: "none",
        backgroundColor: "rgba(255, 255, 255, 1)",
    },
}));

const ReglementExpertDialog = ({ payment }) => {
    const classes = useStyles();

    const fields = [
        { label: 'Type Mission', value: payment.missionType || "N/A", class: classes.generalInput },
        { label: 'Type expert', value: payment.inspectorType || "N/A", class: classes.generalInput },
        { label: 'Expert', value: payment.inspector || "N/A", class: classes.generalInput },
        { label: 'Cause/ Bien', value: payment.cause || "N/A", class: classes.generalInput },
        { label: 'Date désignation', value: getDateTimeFromString(payment.designationDate || 'N/A'), class: classes.generalInput },
        { label: 'Date saisie Honoraire', value: getDateTimeFromString(payment.feeEntryDate || 'N/A'), class: classes.generalInput },
        { label: 'Date MAJ Honoraire', value: getDateTimeFromString(payment.feeEntryDate || 'N/A'), class: classes.generalInput },
        { label: 'Frais Timbre', value: payment.stampFee || "N/A", class: classes.specialInput },
        { label: 'Montant expertise', value: payment.totalAmountTcc || "N/A", class: classes.specialInput },
        { label: 'Frais de déplacement', value: payment.travelFee || "N/A", class: classes.specialInput },
        { label: 'Montant des déductions', value: payment.deductionAmounts || "N/A", class: classes.specialInput },
        { label: 'Facture', value: payment.invoice || "N/A", class: classes.specialInput },
        { label: 'Date facturation', value: getDateTimeFromString(payment.invoiceDate || 'N/A'), class: classes.specialInput },
        { label: 'Note', value: payment.note || "N/A", class: classes.noteInput, isNote: true },
        { label: 'Montant du à l\'expert', value: payment.inspectionAmount || "N/A", class: classes.montantValue, labelClass: classes.montantLabel },
    ];

    return (
        <div>
            {fields.map((field, index) => (
                <Grid container className={classes.container} key={index} spacing={2}>
                    <Grid item xs={6} container alignItems={field.isNote ? 'flex-start' : 'center'}>
                        <div className={field.labelClass || classes.labelInput}>{field.label}</div>
                    </Grid>
                    <Grid item xs={6} container justifyContent="flex-end" alignItems={field.isNote ? 'flex-start' : 'center'}>
                        <input className={field.class} type="text" value={field.value} disabled />
                    </Grid>
                </Grid>
            ))}
        </div>
    );
};

export default ReglementExpertDialog;
